/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-30 17:42:26
 * @LastEditors: liuziwei
 * @Description: 天降弹窗
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="falling-popup-container">
    <es-popup show="{{fallingSwitch}}" bind:close="closeFalling">
      <!-- 面板部分 -->
      <view class="panel-container" style="{{panelStyle}}">
        <!-- header 部分 -->
        <view class="panel-header">
          <image mode="aspectFill" class="panel-header-image" src="{{headerImage}}" />
        </view>
        <!-- 内容部分 -->
        <view class="panel-content" style="{{panelContentStyle}}">
          <coupon-list listData="{{listData}}" couponTheme="{{couponTheme}}" />
        </view>
        <!-- footer 部分 -->
        <view class="panel-footer" style="{{panelFooterStyle}}">
          <coupon-btn
            buttonTheme="{{buttonTheme}}"
            bind:receiveFallingCoupon="receiveFallingCoupon"
          />
        </view>
      </view>
      <image bindtap="closeFalling" class="close-icon" src="{{closeIcon}}" />
    </es-popup>
  </view>
</template>

<script>
  import { sendEvent } from '@/utils'
  import { couponFromConf } from '@/config/coupon'
  import { trackEvent } from '@/common/track'
  import { couponStatusConf } from '@/config/coupon'
  import { getStorage } from '@/utils/storage'
  import { is, getEnvInfo, canIUse, subscribe, locate } from '@didi/webx-js'
  import { mpx, createComponent } from '@didi/es-mpx-creator'
  import { receiveCoupon, handleFallingData } from '@/utils/coupon'
  import { ZHUNXINGAPI, ACTIVITY_ID } from '@/config/falling-popup/constant'

  createComponent({
    props: {
      fallingConf: {
        type: Object,
        value: () => {}
      }
    },
    data: {
      listData: null, // 天降组件数据
      zhunxingConf: {
        imp_tracks: '', // 准星曝光埋点回调
        couponCbUrl: '', // 领取优惠券回调地址
        activity_id: '', // 准星活动 id
        click_tracks: '', // 准星点击埋点回调
        wechat_extra: {} // 拉订阅透传 pope 的信息
      },
      fallingSwitch: false, // 天降开关
      closeIcon: 'https://ut-static.udache.com/webx/sfc/zDAAD6_KoVVbL7DpWKbcG.png'
    },
    computed: {
      // 面板皮肤配置
      panelTheme() {
        return this.fallingConf?.themeConf?.panel || {}
      },
      // 券皮肤配置
      couponTheme() {
        return this.fallingConf?.themeConf?.coupon || {}
      },
      // 按钮皮肤配置
      buttonTheme() {
        return this.fallingConf?.themeConf?.button || {}
      },
      // 面板样式
      panelStyle() {
        return `background-color: ${
          this.panelTheme?.backgroundColor ?? '#FF6C00'
        }; background-image: url(${this.panelTheme?.backgroundImage}); border:${
          this.panelTheme?.border
        }`
      },
      // 头图
      headerImage() {
        return this.panelTheme?.headerImage ?? ''
      },
      // 面板 content 部分样式
      panelContentStyle() {
        return `padding-bottom: ${this.listData?.length <= 2 ? 13 : 0}px`
      },
      // 面板 footer 部分样式
      panelFooterStyle() {
        return `background-color: ${this.panelTheme?.backgroundColor ?? '#FF6C00'}`
      },
      // 是否还处于配置页
      isCorrectPage() {
        // 没传默认返回 true
        return this.fallingConf?.pagePath
          ? window.location?.pathname?.includes?.(this.fallingConf?.pagePath)
          : true
      }
    },
    attached() {
      // 获取天降数据
      this.getFallingData()
    },
    methods: {
      // 请求天降接口
      async getFallingData() {
        try {
          const envInfo = await getEnvInfo()
          const userInfo = getStorage('userInfo')
          const locationInfo = await locate({ useQuickOption: 'lat_lng' })
          // 经纬度和环境信息获取慢的情况下, 若用户已跳走, 则不展示天降
          if (!this.isCorrectPage) return
          const { data = {}, success } = await mpx.$http.post(ZHUNXINGAPI, {
            data: {
              ...this.fallingConf?.params,
              ddfp: envInfo?.ddfp,
              openid: envInfo?.openid,
              appversion: envInfo?.appVersion,
              uid: +userInfo?.uid,
              token: userInfo?.token || '',
              lat: parseFloat(locationInfo?.lat) || -1,
              lng: parseFloat(locationInfo?.lng) || -1,
              lang: 'zh-CN',
              utc_offset: 480,
              send_time: Date.now(),
              width: __mpx_mode__ === 'web' ? window.screen.width : '',
              height: __mpx_mode__ === 'web' ? window.screen.height : '',
              platform_type: is('passenger') ? (is('iphone') ? 1 : 2) : 3,
              access_key_id: is('passenger') ? (is('iphone') ? 1 : 2) : 8,
              os: is('passenger') ? (is('iphone') ? 'ios' : 'android') : 'system'
            }
          })
          // 处理边界情况
          if (!success) return
          // 拿到天降券数据
          const res = data?.[this.fallingConf?.params?.resource_names]?.[0] || {}
          // 处理天降券数据
          this.listData = handleFallingData(res?.coupons_info)
          // 记录准星相关回调
          this.zhunxingConf = {
            imp_tracks: res?.imp_tracks,
            activity_id: res?.activity_id,
            couponCbUrl: res?.callback_url,
            click_tracks: res?.click_tracks,
            wechat_extra: res?.wechat_extra
          }
          // 展示天降弹窗
          this.fallingSwitch = !!this.listData.length
          // 准星曝光埋点
          this.reportZhunxing(this.zhunxingConf?.imp_tracks)
          // 业务曝光埋点
          this.reportLog('sw')
        } catch (e) {
          console.log('天降降不了了!', e)
        }
      },
      // 拉起订阅
      cusSubscribe() {
        if (!is('weixin')) return
        try {
          canIUse('subscribe') &&
            subscribe({ activity_id: ACTIVITY_ID, extra_params: this.zhunxingConf?.wechat_extra })
              .then((data) => {
                console.log('微信内嵌h5订阅成功 ', data)
              })
              .catch((error) => {
                console.log('微信内嵌h5订阅失败 ', error)
              })
        } catch (e) {
          console.log('拉起订阅失败', e)
        }
      },
      // 关闭天降
      closeFalling() {
        this.fallingSwitch = false
      },
      // 领取优惠券
      receiveFallingCoupon({ type = '' }) {
        if (type === 'receiveFallingCoupon') {
          receiveCoupon({
            params: {
              from: couponFromConf?.falling ?? 1,
              receive_urls: [this.zhunxingConf?.couponCbUrl]
            },
            cb: () => {
              // 领券成功了, 喜大普奔通知首页接口数据更新
              sendEvent('updateHomePage')
              // 成功就关闭天降
              this.closeFalling()
              // 拉起订阅
              this.cusSubscribe()
              // 业务点击埋点
              this.reportLog('ck')
              // 准星点击埋点
              this.reportZhunxing(this.zhunxingConf?.click_tracks)
            }
          })
        }
      },
      // 准星埋点
      reportZhunxing(url = []) {
        if (!url?.length) return
        Promise.all(url?.map?.((item) => mpx.$http.get(item)))
      },
      // 业务埋点
      reportLog(type = '') {
        if (type === 'sw') {
          // 埋点上报信息
          const detail = this.listData?.map?.((item) => {
            return {
              batch_id: item?.batchId,
              pope_id: this.zhunxingConf?.activity_id,
              status: item?.is_appointment_backward_coupon
                ? couponStatusConf?.locked?.status // 待解锁
                : couponStatusConf?.unclaimed?.status // 待领取
            }
          })
          // 曝光埋点
          trackEvent('userteam_train_home_pop_sw', 'UT-火车票-首页-天降弹窗-展现', {
            detail,
            num: this.listData.length
          })
        }
        if (type === 'ck') {
          // 点击埋点
          trackEvent('userteam_train_home_pop_ck', 'UT-火车票-首页-天降弹窗-点击')
        }
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .panel-container
    width 260px
    max-height 314px
    border-radius 28px
    position relative
    overflow hidden
    background-size cover
    background-repeat repeat
    background-position center
    .panel-header
      height 64px
      .panel-header-image
        width 100%
        height 100%
    .panel-content
      max-height 180px
      overflow-y auto
    .panel-footer
      height 70px
      display flex
      justify-content center
      align-items center
      overflow hidden
  .close-icon
    width 36px
    height 36px
    margin 20px 0 0 calc(260px / 2 - 36px / 2)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'coupon-btn': './coupon-btn',
      'coupon-list': './coupon-list',
      'es-popup': '@didi/es-mpx-ui/lib/popup'
    }
  }
</script>
